import { Component, OnInit } from '@angular/core';
import {GeneralService} from '../services/general.service'
import { ActivatedRoute } from '@angular/router';
import { DateService } from '../services/date.service';
import {ActionsService} from '../services/actions.service'
@Component({
  selector: 'app-planning-action',
  templateUrl: './planning-action.component.html',
  styleUrls: ['./planning-action.component.scss']
})
export class PlanningActionComponent implements OnInit 
{

  constructor(public generalService :GeneralService,public dateServise : DateService,public actionsService:ActionsService, public route: ActivatedRoute) { }
  avtActions=[{avtAction_Code:"001",avtAction_Intitule:"action1",avtAction_dateDeb:"1/1/2001",avtAction_dateFin:"1/1/2000"},{avtAction_Code:"001",avtAction_Intitule:"action2",avtAction_dateDeb:"1/1/2001",avtAction_dateFin:"1/1/2000"}];

  param;
  successLoadData = false;
  showCalendar = false;
  avtAction_Code;
  date;
  listeAction;
  listeActionD;
  intervale=30;
  date_Debut;
  date_Fin;
  events=[];
  expanded = true;
  listeClients;
  listeColl;
  listWeek;
  listMonth;
  defaultDate;
  ngOnInit()
  {
    this.date_Debut = new Date();
    this.date_Debut.setMonth(this.date_Debut.getMonth()-2);
    this.date_Debut.setDate(1);
    this.date_Fin = new Date();
    this.date_Fin.setMonth(this.date_Fin.getMonth()+2);
    this.date_Fin.setDate(1);
    this.readParamUrl();
  }
  setAction()
  {
    if(this.generalService.isNotEmpty(this.generalService.collaborateurConnecter))
    {
      if(this.param == "mon_planning_action")
      {
        this.generalService.rechercheTable(this.generalService.urlListeActionCol+this.generalService.collaborateurConnecter).subscribe( action => 
        {
          this.avtActions = action;  
          this.successLoadData = true;
        });
      }
      else if(this.param == "planning_action")
      {
        this.generalService.rechercheTable(this.generalService.urlListActionFull).subscribe( action => 
        {
          this.avtActions = action;  
          this.successLoadData = true;
        });
      }    
      else
      {
        this.generalService.rechercheTable(this.generalService.urlListActionFull).subscribe( action => 
        {
          this.avtActions = action;  
          this.avtAction_Code = this.param;
          if(this.date != "1" && this.intervale != 1)
          {
            this.afficherDate();
            this.showDetaille( this.date,  this.intervale);
          }
          this.successLoadData = true;
        });
      }      
    }
    else
      setTimeout(()=>
      {
        this.setAction
      },100)
  }
  readParamUrl()
  {
    this.route.params.subscribe(params => 
    {
      this.param = params['param'];
      this.date = params['date'];
      this.intervale = params['intervale'];
      this.init();
    });
  }
  init()
  {
    this.date_Debut = new Date();
    this.date_Debut.setMonth(this.date_Debut.getMonth()-2);
    this.date_Debut.setDate(1);
    this.date_Fin = new Date();
    this.date_Fin.setMonth(this.date_Fin.getMonth()+2);
    this.date_Fin.setDate(1);
    this.showCalendar = false;
    this.setAction()
    this.successLoadData = true;
  }
  async afficherDate()
  {
    if(this.avtAction_Code  != undefined)
    {
      this.listeActionD =await this.generalService.rechercheTable(this.generalService.urlListeAvtActionDDFCodeAction+this.avtAction_Code+","+ this.dateServise.setFormatDateRechercheServer(this.date_Debut)+","+this.dateServise.setFormatDateRechercheServer(this.date_Fin)).toPromise();
      this.listWeek = this.dateServise.getListWeek(this.date_Debut,this.date_Fin);
      this.listMonth = this.dateServise.getListMonth(this.date_Debut,this.date_Fin,0);
      this.actionsService.enableDesableBouton(this.listWeek,this.listMonth,this.listeActionD);
    }
    else
      this.generalService.dialogSuccess("veuillez choisir un client",false)
    

  }
 
  async showDetaille(date, intervale)
  {
    this.defaultDate = this.dateServise.convertStrToDate(date);
    this.intervale = intervale    
    this.events = [];
    this.showCalendar = false;
    this.listeAction = this.avtActions.filter(action =>
    {
      return action.avtAction_Code == this.avtAction_Code;
    });
    this.listeActionD =await this.generalService.rechercheTable(this.generalService.urlListeAvtActionDDFCodeAction+this.avtAction_Code+","+ this.dateServise.setFormatDateRechercheServer(this.date_Debut)+","+this.dateServise.setFormatDateRechercheServer(this.date_Fin)).toPromise();
    if(this.listeAction != undefined && this.listeAction.length>0)
    {
      this.date_Debut = new Date(this.listeAction[0].avtAction_dateDeb);
      this.date_Fin = new Date(this.listeAction[0].avtAction_dateFin);
    }
    this.listeClients = await this.generalService.rechercheTable(this.generalService.urlListClientFull).toPromise();
    this.listeColl = await this.generalService.rechercheTable(this.generalService.urlListPerso).toPromise();
    this.events = this.actionsService.setCalendar(this.listeAction,this.listeActionD,this.events,this.listeClients,this.listeColl,this.param);
    
    this.showCalendar = true;
  }
}
